import { render } from "./Jump.vue?vue&type=template&id=0935ef52"
const script = {}

import "./Jump.vue?vue&type=style&index=0&id=0935ef52&lang=less&scope=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__